import { render, staticRenderFns } from "./SpireBloodResultTabsComponent.vue?vue&type=template&id=88aa4202"
import script from "./SpireBloodResultTabsComponent.vue?vue&type=script&lang=js"
export * from "./SpireBloodResultTabsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports